
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[resort]/reizen-boeken",
      function () {
        return require("private-next-pages/[region]/[resort]/reizen-boeken.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[resort]/reizen-boeken"])
      });
    }
  